module.exports = __webpack_public_path__ + "media/img/frontend_application/myinvitation-blank-e3dc8003ae4dc598ddd42c75a57426f5.png";